<template>
    <div class="common-title-box">
        <div class="common-title">{{title}}</div>
        <ul class="tag-list">
            <li :class="[{'active': curTag === item.value}]" v-for="item in realList" :key="item.tagKey" @click="changeTag(item.value)">{{item.tagName}}</li>
        </ul>
        <slot></slot>
        <div v-if="props.showMore">
            <a class="more" @click="goMore" href="javascript:;">更多 ></a>
        </div>
    </div>
</template>
<script setup>
import { ref, computed } from 'vue';

    const props = defineProps({
        title: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        },
        showMore: {
            type: Boolean,
            default: true
        },
        tagList: {
            type: Array,
            default: () => {
                return []
            }
        }
    })

    const realList = computed(() => {
        return props.tagList.filter(item => item.checked);
    })

    const emit = defineEmits(['goMore', 'changeTag'])

    const goMore = () => {
        emit('goMore');
    }

    const curTag = ref([]);
    const changeTag = (tag = []) => {
        curTag.value = curTag.value === tag ? [] : tag
        emit('changeTag', curTag.value);
    }
</script>

<style lang="scss" scoped>
    .common-title-box {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        margin-top: 40px;
        border-bottom: 1px solid var(--home-border-color);
        .common-title {
            border-bottom: 4px solid var(--home-main-color);
            padding-bottom: 10px;
            font-size: 22px;
            font-weight: bold;
            color: var(--home-main-color);
            line-height: 29px;
            margin-bottom: -1px;
        }
        .more {
            font-size: 14px;
            color: var(--home-main-color);
            line-height: 14px;
            margin-top: 10px;
            display: block;
            user-select: none;
        }
        .tag-list {
            flex: 1;
            display: flex;
            padding: 0 20px;
            margin-top: 10px;
            li {
                margin: 0 10px;
                line-height: 14px;
                cursor: pointer;
                user-select: none;
                &.active {
                    color: var(--home-main-color);
                }
            }
        }
    }
</style>
